export default {
  name: "ExchangeRateCard",
  props: {
    title: { type: String, default: "EXCHANGE RATE" },
    value: { type: String, default: "R0" },
    subtext: { type: String, default: "per verified job" }
  }
};